import axios from "axios";
import { del, get, post, patch,  put } from "./notes_api_helper";
import * as url from "./notes_url_helper";





// Get features
export const getNotes = () => get(url.GET_NOTES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewNote = note => post(url.ADD_NEW_NOTE, note, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateNote = note => patch(`${url.UPDATE_NOTE}/${note.id}`,  note);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteNote = note => del(`${url.DELETE_NOTE}/${note.id}`);







export {
  //getLoggedInUser,
  
  
};
